module.exports = __webpack_public_path__ + "images/emoji/up.2e469dcd97604f66bebd.png";